
import Vue from 'vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'


const dataList = [{
img:"",
form:"系统消息",
time:"2019-12-23 12:22",
msg:"您已成功开通服务器，您已成功登录，您已修您已成功开通服务器，您已成功登录，您已修"
},{
img:"",
form:"爱哭的毛毛虫",
time:"2019-12-23 12:22",
msg:"您已成功开通服务器，您已成功登录，您已修"
},{
img:"",
form:"系统消息",
time:"2019-12-23 12:22",
msg:"您已成功开通服务器，您已成功登录，您已修"
}]

export default {
components: {
XHeader,
Tab,
TabItem
},
created(){
this.getMessage();
},

data () {
return {
tabIndex:0,
model:{pageSize:0},
messageList:[],
loading: false,
finished: false,
checkDel:[],
}
},
methods: {
getMessage(){
this.$http.post(this.global.httpUrl + '/rest/v1/m/muserMessage/getMessageList',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.messageList = res.body.rows;
console.log(res.body.rows);
}
},function(res){
console.log(res.status);
});
},
changeMessage(i){
if(i==2){
this.model.messageStatus = null;
}
if(i==1 || i==0){
this.model.messageStatus = i;
}
this.getMessage();
},
onLoad() {

setTimeout(() => {
this.model.pageSize=this.model.pageSize+10;
this.$http.post(this.global.httpUrl + '/rest/v1/m/muserMessage/getMessageList',this.model,{emulateJSON:true}).then(function(res){
if(res.body.success)
{
this.messageList = res.body.rows;
console.log( res.body.dbTypes+111111111111);

this.loading = false;

if (this.messageList.length >= res.body.total) {
this.finished = true;
}
}
},function(res){
console.log(res.status);
});
}, 500);
},
checkSwich:function(item,index){
if(item.check){
Vue.set(item,'check',false);
for(let i=0;i<this.checkDel.length;i++){
if(this.checkDel[i] == item.id){
this.checkDel.splice(i,1);
}
}
console.log(this.checkDel);

}else{
Vue.set(item,'check',true);
this.checkDel.push(item.id);
console.log(this.checkDel);
}
}
}
}



// WEBPACK FOOTER //
// ./src/views/user/userMessageManage.vue